export const isModalTriggerClass = function (c?: string) {
  if (!c) return false;
  return Boolean(c.match(/modal-trigger:/));
};
